module.exports = __webpack_public_path__ + "6088c9ceb092913b54d7235ee2e56f2c.svg";